import { USER_DETAIL } from '@/store/modules/user/types';

export default {
  userDetail: state => state[USER_DETAIL],
};
